import { Filters } from 'angular-slickgrid';
import { FieldDefinition } from '../field-definition';
import { GenericFormField } from '../../generic-form/model/generic-field';
import { ControlTypes } from '../../generic-form/enums/control-types';
import { InputTypes } from '../../generic-form/enums/input-type';
import { BaseFieldBuilder } from './field-builder.base';
import { localizeWithFallback } from '../../utils/localization-utils';
import { checkboxFormatter } from '../../generic-table/formatters/checkbox-formatter';
import { CustomCheckboxEditor } from '../../generic-table/editors/custom-checkbox-editor';

export class CheckboxFieldBuilder extends BaseFieldBuilder {
  private _required = false;

  constructor(key: string, label: string) {
    super(key, label, ControlTypes.Checkbox);
    this._type = 'boolean';
  }

  build(): FieldDefinition {
    const column = this.getBaseColumnConfig();
    const localizedLabel = this.getLocalizationKey();

    // Set default formatter for checkboxes if not specified
    if (!column.formatter) {
      column.formatter = checkboxFormatter;
    }

    column.cssClass = [
      column.cssClass,
      'checkbox-cell',
      this.readOnlyValue ? 'disabled' : '',
    ].filter(Boolean).join(' ');

    // Factory to create checkbox editor
    if (!this.readOnlyValue) {
      column.createEditor = (_localizationService: any) => {
        return {
          model: CustomCheckboxEditor,
          required: this._required,
        };
      };
    }

    // Factory to create checkbox filter (true/false select)
    column.createFilter = (localizationService: any) => {
      const yesLabel = localizeWithFallback(localizationService, 'LanguageService::True');
      const noLabel = localizeWithFallback(localizationService, 'LanguageService::False');
      return {
        model: Filters.singleSelect,
        collection: [
          { value: true, label: yesLabel },
          { value: false, label: noLabel },
        ],
      };
    };

    return {
      key: this.key,
      label: localizedLabel,
      column,
      fieldOptions: new GenericFormField({
        key: this.key,
        label: localizedLabel,
        controlType: this._controlType,
        type: InputTypes.Checkbox,
        required: this._required,
        hidden: this.hideInChildFormsValue,
        hiddenByDefault: this.hideByDefaultValue,
        readOnly: this.readOnlyValue,
        showReadOnlyInForm: this.showReadOnlyInFormValue,
        dependencies: this.dependencyRules.length ? this.dependencyRules : undefined,
        prefilter: this.prefilterOptions,
      }),
    };
  }
}
